import { useEffect, useState } from "react"

export function useTokenSectionObserver(mounted: boolean) {
  const [tokenInView, setTokenInView] = useState(false)

  useEffect(() => {
    if (!mounted || typeof window === "undefined") return

    const target = document.getElementById("token")
    if (!target) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return
        setTokenInView(entry.isIntersecting)
      },
      {
        root: null,
        threshold: 0.3, // Trigger when 30% of the section is visible
      },
    )

    observer.observe(target)
    return () => observer.disconnect()
  }, [mounted])

  return tokenInView
}
